module.exports = __webpack_public_path__ + "img/ic-lightbulb.0c6fe729.svg";